module.exports = __webpack_public_path__ + "static/img/cover-3.deaafa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/color-theme/img/slider/cover-3.jpg
// module id = O9P6
// module chunks = 1